module.exports = __webpack_public_path__ + "img/pix-logo.319bc364.png";